// import React, { useEffect, useRef } from 'react'
// import {
//   UserOutlined,
//   DollarOutlined,
//   ManOutlined,
//   WomanOutlined,
//   TeamOutlined,
//   IdcardOutlined,
//   FundOutlined,
//   TrophyOutlined,
//   SmileOutlined,
// } from '@ant-design/icons'

// import { Chart, registerables } from 'chart.js'

// Chart.register(...registerables)

// export default function Dashboard() {
//   return (
//     <>
//       <style>{`
//         .dashboard-container {
//           padding: 20px;
//           min-height: 100vh;
//           background: linear-gradient(135deg, #eef2ff, #f8fafc);
//         }

//         .section-title-modern {
//           font-size: 15px;
//           font-weight: 700;
//           color: #ffffff;
//           margin-bottom: 10px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//           background: linear-gradient(135deg, #557dff, #f8fafc);
//         }

//         .section-title-modern::before {
//           content: "";
//           width: 4px;
//           height: 14px;
//           border-radius: 4px;
//           background: linear-gradient(180deg, #3b82f6, #6366f1);
//         }

//         .stats-grid-modern {
//           display: grid;
//           grid-template-columns: repeat(5, 1fr);
//           gap: 14px;
//         }

//         @media (max-width: 992px) {
//           .stats-grid-modern { grid-template-columns: repeat(3, 1fr); }
//         }
//         @media (max-width: 576px) {
//           .stats-grid-modern { grid-template-columns: repeat(1, 1fr); }
//         }

//         .modern-card {
//           position: relative;
//           padding: 14px;
//           border-radius: 16px;
//           background: linear-gradient(145deg, #ffffff, #f1f5f9);
//           border: 1px solid rgba(255,255,255,0.7);
//           box-shadow: 0 6px 18px rgba(0,0,0,0.05);
//           transition: all 0.25s ease;
//           overflow: hidden;
//         }

//         .modern-card:hover {
//           transform: translateY(-4px);
//           box-shadow: 0 12px 25px rgba(59,130,246,0.15);
//         }

//         .modern-card::after {
//           content: "";
//           position: absolute;
//           width: 90px;
//           height: 90px;
//           background: radial-gradient(circle, rgba(59,130,246,0.18), transparent);
//           top: -20px;
//           right: -20px;
//         }

//         .icon-box {
//           width: 36px;
//           height: 36px;
//           border-radius: 10px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           background: linear-gradient(135deg, #3b82f6, #6366f1);
//           color: white;
//           font-size: 18px;
//         }

//         .card-content { margin-top: 12px; }

//         .value {
//           font-size: 18px;
//           font-weight: 800;
//           color: #0f172a;
//         }

//         .label {
//           font-size: 12px;
//           color: #64748b;
//           margin-top: 2px;
//         }

//         /* ── CHART SECTION ── */
//         .charts-row {
//           display: grid;
//           grid-template-columns: 1fr 1fr;
//           gap: 18px;
//           margin-top: 4px;
//         }

//         @media (max-width: 768px) {
//           .charts-row { grid-template-columns: 1fr; }
//         }

//         .chart-card {
//           background: linear-gradient(145deg, #ffffff, #f1f5f9);
//           border: 1px solid rgba(255,255,255,0.7);
//           border-radius: 16px;
//           box-shadow: 0 6px 18px rgba(0,0,0,0.05);
//           padding: 18px 18px 14px;
//         }

//         .chart-card-title {
//           font-size: 13px;
//           font-weight: 700;
//           color: #334155;
//           margin-bottom: 10px;
//           display: flex;
//           align-items: center;
//           gap: 8px;
//         }

//         .chart-card-title::before {
//           content: "";
//           width: 4px;
//           height: 14px;
//           border-radius: 4px;
//           background: linear-gradient(180deg, #3b82f6, #6366f1);
//           flex-shrink: 0;
//         }

//         .chart-legend {
//           display: flex;
//           gap: 16px;
//           margin-bottom: 10px;
//         }

//         .legend-item {
//           display: flex;
//           align-items: center;
//           gap: 5px;
//           font-size: 12px;
//           color: #64748b;
//         }

//         .legend-dot {
//           width: 10px;
//           height: 10px;
//           border-radius: 2px;
//           flex-shrink: 0;
//         }

//         .chart-wrapper {
//           position: relative;
//           width: 100%;
//           height: 220px;
//         }
//       `}</style>

//       <div className="dashboard-container rounded">
//         {/* ── GENDER BAR CHARTS ── */}
//         <div className="section py-3 my-1">
//           <h3 className="section-title-modern py-1">Gender-wise Analysis</h3>
//           <div className="charts-row">
//             <GenderBarChart
//               chartId="todayGenderChart"
//               title="Today's gender-wise entries"
//               maleData={[70, 35, 18, 22]}
//               femaleData={[50, 25, 12, 18]}
//             />
//             <GenderBarChart
//               chartId="yearlyGenderChart"
//               title="Yearly gender-wise entries"
//               maleData={[840, 420, 216, 264]}
//               femaleData={[600, 300, 144, 216]}
//             />
//           </div>
//         </div>

//         <Section title="Single Entry">
//           <StatCard icon={<TeamOutlined />} label="Total" value="120" />
//           <StatCard icon={<SmileOutlined />} label="Age < 15" value="40" />
//           <StatCard icon={<UserOutlined />} label="Age > 15" value="80" />
//           <StatCard icon={<ManOutlined />} label="Male" value="70" />
//           <StatCard icon={<WomanOutlined />} label="Female" value="50" />
//         </Section>

//         <Section title="Monthly Pass">
//           <StatCard icon={<TeamOutlined />} label="Total" value="60" />
//           <StatCard icon={<SmileOutlined />} label="Age < 15" value="20" />
//           <StatCard icon={<UserOutlined />} label="Age > 15" value="40" />
//           <StatCard icon={<ManOutlined />} label="Male" value="35" />
//           <StatCard icon={<WomanOutlined />} label="Female" value="25" />
//         </Section>

//         <Section title="Yearly Pass">
//           <StatCard icon={<TeamOutlined />} label="Total" value="30" />
//           <StatCard icon={<SmileOutlined />} label="Age < 15" value="10" />
//           <StatCard icon={<UserOutlined />} label="Age > 15" value="20" />
//           <StatCard icon={<ManOutlined />} label="Male" value="18" />
//           <StatCard icon={<WomanOutlined />} label="Female" value="12" />
//         </Section>

//         <Section title="Lifetime Pass">
//           <StatCard icon={<TeamOutlined />} label="Total" value="40" />
//           <StatCard icon={<SmileOutlined />} label="Age < 15" value="15" />
//           <StatCard icon={<UserOutlined />} label="Age > 15" value="25" />
//           <StatCard icon={<ManOutlined />} label="Male" value="22" />
//           <StatCard icon={<WomanOutlined />} label="Female" value="18" />
//         </Section>

//         <Section title="Fee Collection">
//           <StatCard icon={<DollarOutlined />} label="Today" value="₹5,000" />
//           <StatCard icon={<FundOutlined />} label="Monthly" value="₹15,000" />
//           <StatCard icon={<TrophyOutlined />} label="Annual" value="₹25,000" />
//           <StatCard
//             icon={<TeamOutlined />}
//             label="Single Entry"
//             value="₹8,000"
//           />
//           <StatCard
//             icon={<IdcardOutlined />}
//             label="Lifetime"
//             value="₹50,000"
//           />
//         </Section>
//       </div>
//     </>
//   )
// }

// /* ── GENDER BAR CHART COMPONENT ── */
// const LABELS = ['Single Entry', 'Monthly Pass', 'Yearly Pass', 'Lifetime Pass']

// const GenderBarChart = ({ chartId, title, maleData, femaleData }) => {
//   const canvasRef = useRef(null)
//   const chartRef = useRef(null)

//   useEffect(() => {
//     if (!canvasRef.current) return

//     if (chartRef.current) {
//       chartRef.current.destroy()
//     }

//     chartRef.current = new Chart(canvasRef.current, {
//       type: 'bar',
//       data: {
//         labels: LABELS,
//         datasets: [
//           {
//             label: 'Male',
//             data: maleData,
//             backgroundColor: 'rgba(59,130,246,0.85)',
//             borderRadius: 8,
//             borderSkipped: false,
//             borderWidth: 0,
//             barPercentage: 0.55,
//           },
//           {
//             label: 'Female',
//             data: femaleData,
//             backgroundColor: 'rgba(232,121,249,0.85)',
//             borderRadius: 8,
//             borderSkipped: false,
//             borderWidth: 0,
//             barPercentage: 0.55,
//           },
//         ],
//       },
//       options: {
//         responsive: true,
//         maintainAspectRatio: false,
//         plugins: {
//           legend: { display: false },
//           tooltip: {
//             backgroundColor: '#1e293b',
//             titleColor: '#e2e8f0',
//             bodyColor: '#cbd5e1',
//             cornerRadius: 8,
//             padding: 10,
//             callbacks: {
//               label: (ctx) => ` ${ctx.dataset.label}: ${ctx.parsed.y}`,
//             },
//           },
//         },
//         scales: {
//           x: {
//             grid: { display: false },
//             ticks: { color: '#64748b', font: { size: 11 } },
//             border: { display: false },
//           },
//           y: {
//             beginAtZero: true,
//             grid: { color: 'rgba(100,116,139,0.1)' },
//             ticks: { color: '#64748b', font: { size: 11 } },
//             border: { display: false },
//           },
//         },
//       },
//     })

//     return () => {
//       chartRef.current?.destroy()
//     }
//   }, [maleData, femaleData])

//   return (
//     <div className="chart-card">
//       <div className="chart-card-title">{title}</div>
//       <div className="chart-legend">
//         <span className="legend-item">
//           <span
//             className="legend-dot"
//             style={{ background: 'rgba(59,130,246,0.85)' }}
//           />
//           Male
//         </span>
//         <span className="legend-item">
//           <span
//             className="legend-dot"
//             style={{ background: 'rgba(232,121,249,0.85)' }}
//           />
//           Female
//         </span>
//       </div>
//       <div className="chart-wrapper">
//         <canvas ref={canvasRef} />
//       </div>
//     </div>
//   )
// }

// /* ── SECTION ── */
// const Section = ({ title, children }) => (
//   <div className="section py-3 my-1">
//     <h3 className="section-title-modern py-1">{title}</h3>
//     <div className="stats-grid-modern">{children}</div>
//   </div>
// )

// /* ── STAT CARD ── */
// const StatCard = ({ icon, label, value }) => (
//   <div className="modern-card">
//     <div className="icon-box">{icon}</div>
//     <div className="card-content">
//       <h2 className="value">{value}</h2>
//       <p className="label">{label}</p>
//     </div>
//   </div>
// )

import React, { useEffect, useRef } from 'react'
import {
  UserOutlined,
  DollarOutlined,
  ManOutlined,
  WomanOutlined,
  TeamOutlined,
  IdcardOutlined,
  FundOutlined,
  TrophyOutlined,
  SmileOutlined,
} from '@ant-design/icons'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)

export default function Dashboard() {
  return (
    <>
      <style>{`
        .dashboard-container {
          padding: 12px;
          min-height: 100vh;
          background: linear-gradient(135deg, #eef2ff, #f8fafc);
        }

        @media (min-width: 768px) {
          .dashboard-container { padding: 20px; }
        }

        /* ── SECTION TITLE ── */
        .section-title-modern {
          font-size: 14px;
          font-weight: 700;
          color: #ffffff;
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #557dff, #f8fafc);
          padding: 6px 10px;
          border-radius: 8px;
        }

        .section-title-modern::before {
          content: "";
          width: 4px;
          height: 14px;
          border-radius: 4px;
          background: linear-gradient(180deg, #3b82f6, #6366f1);
          flex-shrink: 0;
        }

        /* ── STATS GRID ──
             Mobile  : 2 columns
             Tablet  : 3 columns  (≥ 576px)
             Desktop : 5 columns  (≥ 992px)
        ── */
        .stats-grid-modern {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 10px;
        }

        @media (min-width: 576px) {
          .stats-grid-modern { grid-template-columns: repeat(3, 1fr); gap: 12px; }
        }

        @media (min-width: 992px) {
          .stats-grid-modern { grid-template-columns: repeat(5, 1fr); gap: 14px; }
        }

        /* ── STAT CARD ── */
        .modern-card {
          position: relative;
          padding: 12px;
          border-radius: 14px;
          background: linear-gradient(145deg, #ffffff, #f1f5f9);
          border: 1px solid rgba(255,255,255,0.7);
          box-shadow: 0 4px 12px rgba(0,0,0,0.05);
          transition: all 0.25s ease;
          overflow: hidden;
        }

        @media (min-width: 768px) {
          .modern-card { padding: 14px; border-radius: 16px; }
        }

        .modern-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 22px rgba(59,130,246,0.15);
        }

        .modern-card::after {
          content: "";
          position: absolute;
          width: 70px;
          height: 70px;
          background: radial-gradient(circle, rgba(59,130,246,0.15), transparent);
          top: -16px;
          right: -16px;
        }

        .icon-box {
          width: 32px;
          height: 32px;
          border-radius: 9px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: linear-gradient(135deg, #3b82f6, #6366f1);
          color: white;
          font-size: 16px;
        }

        @media (min-width: 768px) {
          .icon-box { width: 36px; height: 36px; font-size: 18px; }
        }

        .card-content { margin-top: 10px; }

        .value {
          font-size: 16px;
          font-weight: 800;
          color: #0f172a;
          line-height: 1.2;
        }

        @media (min-width: 768px) {
          .value { font-size: 18px; }
        }

        .label {
          font-size: 11px;
          color: #64748b;
          margin-top: 2px;
        }

        @media (min-width: 768px) {
          .label { font-size: 12px; }
        }

        /* ── CHARTS ROW ──
             Mobile  : 1 column  (stacked)
             Desktop : 2 columns (≥ 768px)
        ── */
        .charts-row {
          display: grid;
          grid-template-columns: 1fr;
          gap: 14px;
          margin-top: 4px;
        }

        @media (min-width: 768px) {
          .charts-row { grid-template-columns: 1fr 1fr; gap: 18px; }
        }

        /* ── CHART CARD ── */
        .chart-card {
          background: linear-gradient(145deg, #ffffff, #f1f5f9);
          border: 1px solid rgba(255,255,255,0.7);
          border-radius: 16px;
          box-shadow: 0 6px 18px rgba(0,0,0,0.05);
          padding: 14px 14px 12px;
        }

        @media (min-width: 768px) {
          .chart-card { padding: 18px 18px 14px; }
        }

        .chart-card-title {
          font-size: 12px;
          font-weight: 700;
          color: #334155;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        @media (min-width: 768px) {
          .chart-card-title { font-size: 13px; margin-bottom: 10px; }
        }

        .chart-card-title::before {
          content: "";
          width: 4px;
          height: 14px;
          border-radius: 4px;
          background: linear-gradient(180deg, #3b82f6, #6366f1);
          flex-shrink: 0;
        }

        .chart-legend {
          display: flex;
          gap: 14px;
          margin-bottom: 8px;
        }

        .legend-item {
          display: flex;
          align-items: center;
          gap: 5px;
          font-size: 11px;
          color: #64748b;
        }

        .legend-dot {
          width: 10px;
          height: 10px;
          border-radius: 2px;
          flex-shrink: 0;
        }

        .chart-wrapper {
          position: relative;
          width: 100%;
          height: 200px;
        }

        @media (min-width: 576px) {
          .chart-wrapper { height: 220px; }
        }

        @media (min-width: 992px) {
          .chart-wrapper { height: 240px; }
        }
      `}</style>

      <div className="dashboard-container rounded">

        {/* ── GENDER BAR CHARTS ── */}
        <div className="section py-3 my-1">
          <h3 className="section-title-modern">Gender-wise Analysis</h3>
          <div className="charts-row">
            <GenderBarChart
              title="Today's gender-wise entries"
              maleData={[70, 35, 18, 22]}
              femaleData={[50, 25, 12, 18]}
            />
            <GenderBarChart
              title="Yearly gender-wise entries"
              maleData={[840, 420, 216, 264]}
              femaleData={[600, 300, 144, 216]}
            />
          </div>
        </div>

        <Section title="Single Entry">
          <StatCard icon={<TeamOutlined />} label="Total" value="120" />
          <StatCard icon={<SmileOutlined />} label="Age < 15" value="40" />
          <StatCard icon={<UserOutlined />} label="Age > 15" value="80" />
          <StatCard icon={<ManOutlined />} label="Male" value="70" />
          <StatCard icon={<WomanOutlined />} label="Female" value="50" />
        </Section>

        <Section title="Monthly Pass">
          <StatCard icon={<TeamOutlined />} label="Total" value="60" />
          <StatCard icon={<SmileOutlined />} label="Age < 15" value="20" />
          <StatCard icon={<UserOutlined />} label="Age > 15" value="40" />
          <StatCard icon={<ManOutlined />} label="Male" value="35" />
          <StatCard icon={<WomanOutlined />} label="Female" value="25" />
        </Section>

        <Section title="Yearly Pass">
          <StatCard icon={<TeamOutlined />} label="Total" value="30" />
          <StatCard icon={<SmileOutlined />} label="Age < 15" value="10" />
          <StatCard icon={<UserOutlined />} label="Age > 15" value="20" />
          <StatCard icon={<ManOutlined />} label="Male" value="18" />
          <StatCard icon={<WomanOutlined />} label="Female" value="12" />
        </Section>

        <Section title="Lifetime Pass">
          <StatCard icon={<TeamOutlined />} label="Total" value="40" />
          <StatCard icon={<SmileOutlined />} label="Age < 15" value="15" />
          <StatCard icon={<UserOutlined />} label="Age > 15" value="25" />
          <StatCard icon={<ManOutlined />} label="Male" value="22" />
          <StatCard icon={<WomanOutlined />} label="Female" value="18" />
        </Section>

        <Section title="Fee Collection">
          <StatCard icon={<DollarOutlined />} label="Total" value="₹50,000" />
          <StatCard icon={<TeamOutlined />} label="Single Entry" value="₹10,000" />
          <StatCard icon={<FundOutlined />} label="Monthly" value="₹15,000" />
          <StatCard icon={<TrophyOutlined />} label="Annual" value="₹20,000" />
          <StatCard icon={<IdcardOutlined />} label="Lifetime" value="₹5,000" />
        </Section>

      </div>
    </>
  )
}

/* ── GENDER BAR CHART ── */
const LABELS = ['Single Entry', 'Monthly Pass', 'Yearly Pass', 'Lifetime Pass']

const GenderBarChart = ({ title, maleData, femaleData }) => {
  const canvasRef = useRef(null)
  const chartRef = useRef(null)

  useEffect(() => {
    if (!canvasRef.current) return
    if (chartRef.current) chartRef.current.destroy()

    chartRef.current = new Chart(canvasRef.current, {
      type: 'bar',
      data: {
        labels: LABELS,
        datasets: [
          {
            label: 'Male',
            data: maleData,
            backgroundColor: 'rgba(59,130,246,0.85)',
            borderRadius: 7,
            borderSkipped: false,
            borderWidth: 0,
            barPercentage: 0.55,
          },
          {
            label: 'Female',
            data: femaleData,
            backgroundColor: 'rgba(232,121,249,0.85)',
            borderRadius: 7,
            borderSkipped: false,
            borderWidth: 0,
            barPercentage: 0.55,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: {
            backgroundColor: '#1e293b',
            titleColor: '#e2e8f0',
            bodyColor: '#cbd5e1',
            cornerRadius: 8,
            padding: 10,
            callbacks: {
              label: (ctx) => ` ${ctx.dataset.label}: ${ctx.parsed.y}`,
            },
          },
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              color: '#64748b',
              font: { size: 10 },
              maxRotation: 30,
              minRotation: 0,
            },
            border: { display: false },
          },
          y: {
            beginAtZero: true,
            grid: { color: 'rgba(100,116,139,0.1)' },
            ticks: { color: '#64748b', font: { size: 10 } },
            border: { display: false },
          },
        },
      },
    })

    return () => { chartRef.current?.destroy() }
  }, [maleData, femaleData])

  return (
    <div className="chart-card">
      <div className="chart-card-title">{title}</div>
      <div className="chart-legend">
        <span className="legend-item">
          <span className="legend-dot" style={{ background: 'rgba(59,130,246,0.85)' }} />
          Male
        </span>
        <span className="legend-item">
          <span className="legend-dot" style={{ background: 'rgba(232,121,249,0.85)' }} />
          Female
        </span>
      </div>
      <div className="chart-wrapper">
        <canvas ref={canvasRef} />
      </div>
    </div>
  )
}

/* ── SECTION ── */
const Section = ({ title, children }) => (
  <div className="section py-3 my-1">
    <h3 className="section-title-modern">{title}</h3>
    <div className="stats-grid-modern">{children}</div>
  </div>
)

/* ── STAT CARD ── */
const StatCard = ({ icon, label, value }) => (
  <div className="modern-card">
    <div className="icon-box">{icon}</div>
    <div className="card-content">
      <h2 className="value">{value}</h2>
      <p className="label">{label}</p>
    </div>
  </div>
)